// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"07e5cc8a","455":"0e29a1bc"}[chunkId] + ".chunk.js";
};